var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZscaler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9484 8.59227C17.1984 10.1884 15.833 11.073 14.4291 11.1692C13.5445 12.9961 10.4099 14.2269 7.69836 12.8807C6.54451 13.0538 5.90989 12.7653 5.40989 12.2077C6.40989 10.9384 9.40989 8.63073 13.083 9.84227C15.0445 10.4769 15.5637 8.99612 15.0637 8.43843C13.2176 6.34227 9.04451 8.22689 8.89066 8.38073C10.5253 5.8615 16.4099 5.16919 16.9484 8.59227ZM11.333 5.70766C11.333 5.70766 10.006 5.22689 8.12143 6.03458C8.04451 6.01535 7.96759 5.97689 7.89066 5.93842C9.69836 4.74612 11.2753 4.22689 12.6407 4.43842C11.8137 3.49612 7.89066 2.80381 5.62143 5.05381C2.83297 4.49612 0.890662 6.8615 0.986816 9.01535C1.08297 11.1692 3.44835 12.5346 4.79451 12.1692C4.83297 12.1692 4.8522 12.1692 4.89066 12.1692C5.19835 10.7269 6.40989 7.41919 11.333 5.70766Z",
    fill: "#236BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZscaler);
export default __webpack_public_path__ + "static/media/Zscaler.4284a18bfb160f28a130a1815e6d04b5.svg";
export { ForwardRef as ReactComponent };